import React from "react";

export default function MyGreating({team}) {
    if(!team){team="Toulouse"}
return(
    <div>
        <h1 style={{background:"grey"}}>Hello {team} !</h1>
    </div>
)}